import React from "react";
import ReactTable from "react-table";
import {
  faFileSignature,
  faEnvelope,
  faPrint,
  faFilePrescription,
  faSyncAlt,
  faCheck,
  faEye
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Row, Col } from "reactstrap";
import s from "./styles.scss";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import constants from "../../../utils/constants";
import { stringify as objectToQueryParams } from "query-string";
import isNil from "lodash.isnil";

const DOCUMENT_VALIDATED_STATUS = 6;
const SIGNATURE_EXAMPLE =
  "iVBORw0KGgoAAAANSUhEUgAAAgAAAAB8CAQAAAC1DsDiAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAHdElNRQfhCAkHJCMKdOCdAAAcRElEQVR42u2dd2AVxfbHPyn0lgQDoRdDR4q0gFKkGAWsSFNERFAQgQc8AUUsQRF/WFFQLMADBUQQATuiggI+HlXpUqWHEHpLSO7vj8wOu7fltr13bzLf/SM3yd2Z2XN2Zs6cOfM9oKCgoKCgYEGM5xLbqKUEoaCQ/1CNbGzY+FSJwixEKhEoWBbNiAAgSolCDQAK+Q8Nxc+tShRqAFDIf2ggfv6pRKGgkP9wEBs2bFRWojALEZZqTSFqUpMEShMnroIAZHGG0xxjP/vYygGltnyBGNKJAM4Qh02JwxxEW6AFjWhObWpRgyoeLUnSWccvrGCjei3yuAcgQiwAlJ7zIG7gLibyKxeFmef99Q+v01gJMs9iqNDzu0oUeWvR0ZyX2exzt7e/fqeHcmXmSXwkNDxQiSJvLAGK0JG76Eo5l9+4xG52c5CTpIvrorgzhliqUI1a3Ex5wz23cAtbGc9XSpl5DNoewBYlivCf9VsziwtOZ/BstvExg+lAJQ9dkuV4kBmctCvnW6oqQechRIr3JYtiShjhjPI8w24nHf8iK0ihM7E+2y7JLCBTV+J5HlTizjOoKbS6S4kifOf9O1nGNYeuf5QP6UqRgNRRkXe4oiv7HeUPyCPoLjS6QIkiHBFFTzY5dP3tvELzgHfRyizS1TGXAkr8eQAThD7HK1GEGwoywMHoP8t0kkyssxunZV2zLBbepOALlght3q1EEU4owHAO2zn5fqUvRU2v+Ua2yzqfVYoIe+wTuqymRBE+6MouQ+e/wnRqBK32eDaKejNpopQR1ihGlnDsKmsuTFCPHw2d/zyv2+3Ym49y8vjIZuUMDGs0F3pcq0QRDojjHcOGXBovEheSliTJXYfuSi1hjEeFFj9WorA+epCm6/yXmUiJELZmimjHOqWYMMbrQosjlCisjVjmGgz/BSGPx0vgkmhLolJP2OJ7ocPblSisjGSDx38DrS3RqoWiPcOUgsIWh4QOyytRWBXFmCY4W3P2+Qdaxu2mrR9nKiWFKUqJN+u0EoVVUZcdurn/F6pYqG2N5UFhhfBEK6HB35QozIZvs/Y9rKG2+HyFsXTgoIWeSZs3Civ1hinqi5/blCjMhvd8ABG8wlgZnrGBvmzPM8+mYA3UUwOAVVGYz3VBvpMtefCmrWQIUAhP/CQ0eJsShbUQx++6SD+rhtr8S7RwqlJYmOK40GAZJQorIYE/ZfffR13LtvM70ca+SmVhiRuE/k4qUVgJlXUHff6grGXbWY4MsUApq5QWlmgr95YULIOK8nimjcUBYvMxBymilSuV0sIUTwgNvqdEYRXE687af2Zp73oZzop29lBqC1O8oSI5rYVYtsjuP9Xix2w1LvkDihgsbLFM6PAOJQoroIDclLExw+L0DB1lcHJvpbiwheZrqq5EEXpE8B/Z/edYfPaPl0dI1ioeGcuhLiOYy3JWMINHKO7ye9FcxYaNq0QpoYUe42T3X2bxyLpofpaMBHWU4iyEFrzO33YksScYLjI/26OGZJBWCDk6SX6d9ZbPz/K+fLlGKcVZBBUYYzg0ZrxWUdrJPV3Ef79S4gs1KpEqlHHQTT4/a+AF+VotUua/JdCOhU6SwhivXcQ73KfFcf6fEmFwDGdXiGKeUM8V7ueYpZ9iLC+KT9vop7LJhxgF6cNwmdpTw1m+5Xt2EE0rRlABgJospCOZum9F0kh8KsMQigNRlCSLc2Rygauc4xj/cIIsJWaz8awcp62envlF2dIjluIlyI8ozJOSmVm7zjGTToZt2SLMl/99jWQGkMJsVrJfRHHmdmVyiNV8xCCaUUgJ3Qw0Fr5YG7Mt3c5I3dr/lDxHrhCamX8oR+266kr62nmPilKPLgzVZXLy78pgA+/RNQipZ/LVwmCzEO9+Slr6lftMvgjHaagUFzJE0Is9ho55iY9oCBSiJsk8wavM5w95zi/w12W+5D5lD3ivOGcYwZsAZNOBXy3b9vIspKX4/A+d2K3UGSK05k2aGv6ymR8oTS1upJxXTtlMsVRI51Muc5Zs4CJRFKYYBSlJCSpRgYou2Z7SmM5Ui3usLI/yMp7+HQu38hadubmDSkptIUIZZunIYb034HeyjHd5mp60pDwPiL/Pz6XWeJoxiI/Y5MRrcJVpJCjF+I450qVmXfN/sPRR2FjvZDNJITgemCdJ97LLn2YTi3mLYXShhsMu1FjxrQket6Ewt/CyzAp5na5mvItAI4Vc0EikZbTRy6ItLMlsnao/tfTh5LyMRH7zoMNf4C+WMYWR3EdjYnMpc7q46xGvW1OLFBkKnnNt4WalJO+h8elYde3fmv267aB/KYWFBBEM4YIbs34xk+hPS69tsx9EGW19alUBerPJ0JLBSlXeoY0k/EyyYOsK8qouuiyVdkphIUF53QlRrav9yWxGcw81/TqIvVOU53s8RwQP6shrbExX7NDe4Fshti8t2Lb6hpXeauX4CxFuM2zmfUF/bg7QejtC5HXM9LPTFuVNuZC18YXihvAUNwl/brZkZrcKCvOyzt+bwTh1WDREpv+zOhvsOPcEtPQEGX3iP9pxQrZzoXpbPMN/5NFfq805u3Vzzg67PWeFYKE4S3V6WMgNAS6/RUD9T5VlOJuNyUp5uaM0V4S42liqVTN1+8zZTFVBnyFCBd0S7CpDTaihpyh9VoDKi9O1WHFE5QrtIOY6y7Qomqc4pZtzdqtcMSFDQ90m2wGam1LHKFF+SsBKjJN8BOeoqJToHpstdvqvgy4RiY0MJql0nyFDe85JTfzklMgjEHhL1PB4AMusxRlFMeIJmsrAjRIWaE1NyQ2rpfqup1QUMnTkotTEJyb61LW8k10DWmoP2fa7lCpdY6IQ0syQtySBaYYI7xMMsDgdad5GJ7E5ZyNbEq+YAy2yMNARfF+JcjcqtijX2GEJNvbijJFHkXIM/3copZQT0tlf6/7XTM+2qAXwBDqpWxXp3u6sFOocdYSAzobwRHVRRnLSYPgvo6ZSTUhxkxyOr/GQyXVFcFmEAQXe3vtAPMVypVLnGCkENDdkM//TusANGzY2cbvDtwoRq7vUdqDZKCfpvTKDsI1WWtT1jwllVxPhS9cor9SqhxZy2U78/C4EbSjJU4wwBJXsYzxLqEoXqlGNcpQmntLEOaSTuMwp0jnFSQ6ym91s4axSacBQjGVUBsBGf+aZXp92ht8MOo/9rOB2IIpeguxGQYcouVUS7L3SGJ53OFF+lpUc84leIpudzKG/OiUQEHwq5To+KPW1F7UtMaX0vqL035RiHdFEBtoEE6WZIAeeQF/beYm6SrF+4CEpy1lB8p1r23Ufm1J6KTKxYeOK4o9whJaR/aOg1ViDqS7Pk7u+0tiru04Ilbq+1tNPBQ/5hKpyaF4VNGadIaLGSSaV/z+/uAbytA+gkfhtY1DqbMcIuubq6T3Dfg6wn/0cECv9U05SfpSiNKUpS01qUJ/GdhTUTZjJZN5kCheVqr1AJHPE5utpHiIjSLVq5CEnTSr/N3GIrBUrlYqNWCPGxlYm11OIPmxwM2NfYT0zGElHH3eCo2nAMJbqwla1Y6tD1IFQL/CYlFyPINb6ns90YJ6ht0xyr2BABOexYSPLTdLmQIzvr9ht9F2/9vEZw2gRMGOzMPcxXwZ/5Fz/dUhWpeAcJaQLdlZQ6/3c5GCd5nJRo2BA2QDSMLjuknuddPyDzKSvaT77eJ7lsCGqcLQKBfUAr8hMS3FBrVejGWtuUvmlJdu1ggEtgkAD2sjQ8a+xktFBOd5T2C66cJGlMx1ZAZVEPJ6N4UGueb2oN9G0Gi6IoCYFA3oEweArIrh8zzOX3kGeWUoxXUcpsiXgkeZ5C5OEnHYGnUnvb1FzGdNq0JY2amfIgH8Lsbxkai0JDKNbyMJ32+roLHapQCGXKESqkFK3oNd93PTuqRHLqUQyTtd8Q/L0U5ZhhRwC9qhXwAX6SO9M8HdNLglPjXnQCMKqKUVriAZixOe8HUefSjIzeBiAG1nCO5SlDPFAEQoTIaRwhcuc4zipbGcrxy32DPXINDlac5D4+SFZQX62AiJC75ypdeRAeQEMA0CpfDEAVOcWLpMlZraWMq+wO6zlfeZYaHU+BhtP84YJZZekEhWpJiJBsmlPO4pSiCiygEwucJaTpHGIPewx5bye5pw1cwDQ6jivOr4eSy3IBRw4RNGGyezy+VSBVTIkVxWBzwcDtNavTzfG8gk/sk3EgXgTkv014+kU0B2VaqLszaZJ8HraEXOXNwm0pDkNw2O/SZ+BJTuPdf2idOZuOvtJYTmMOay3wNOMELo67UcHqEFTmlCPmlTxi3SjNF3oAmTzB3OZR3oAnk8L4vY+aLsMidzIDcQSJ6+ceI9ISgEZXOQiGVwSi4yDpi1vYvkXfakqfz/Acmay1uoDQJacK/POwqYTvbnXKb3pNVJJIBLIZiRpZJDNWeAiGUApoognnsrcxK3ihelsgQEgjsfEpy1e31uWW2lOU5oEnFwtkla04mVeZCrX/LZJEF4YT1CJljQikURu9Hqm3WOSjgbwup2EqzKQgSyjP2lWHgAuic8l8kDXjyCJB+nhZC/5PCtYxRo2kslhKgCRfMhlN2U9Jg6mxljguYbJGXKnx/dUoC1taEMdD757nCOcFHyQF3mQM1zkmlwrF6cQpbmBeBJJpB4VDPfG8Db38YCfL7kWBp7hdpBoThJJJPnF67PDFA29xPMu/nMXK0myqt8hGkiVM0V4owoDeMjJFs8/LGMpK7kqX+ecTcDL8i/O0Vr8PBTyJyuli8rLff4qzm0k08ktn+IldrOb3eziAIc5SgbQSgwA61maSw0VSaIlLWgq5+22rKWNX1w+WklXXSwQ2tOduwNiw6w2QUN9dN0/ja1coxi1iRV/qUsKI0L07sRy2Z1VFQ2ckGZVuCKSZJ6ks8O6dgfzWergVuolZps/3Xo9ikgW+e9D/nzDdVbIHjfWTyPuIJlWLmP4DrKe9WxgF4ecHK2u6vEQc5iFLARi6cl4MRsn8gNJ0pr03QKwHwDi6cZ9tHN5UMzGEfawl6Okk046p0nnjHzlszhHcQoQSzHWiMNugR8AEpgqPqUyinliUR1JM54TOQ4eZVTQfGw30pD63ERdKogB8yz7+C/L+cb58NpN+F8/D8vOH88YJweNDjGZxi5mU43o8mm35T4u4wZDjZIG0jRnc2AM3ZnBURc++wss53nuzDX4SSPkmOhV60rwhazpXT+e8i5RxhzdgHY7C7jq9JlOsJRx3Et9j/l9OssQ58DjNbk7kugwNe0R/6ti8lsSQzLP8w1pbnZvTvOqszD8OiaKxly04lO7Q782TjGdtm583HMl82CcW5tih8Mw0YpJjJZmXfAwzsCYYD/nP8MqF8xI5/iGMbT0OKb/GXHfGK/9Lp9ITkbfczd2MxCCFWIA25080zam8BA3+lD+DFHCqwHRSREakMzDjGQQgyR1+sNOPQ45/zMnnVoBGjOYWezQnXZxf52mu+My4JxQX/h4AaLopcv8qr1+P9EtF06BJ+S3R7n9XnfxrfPC+I6Tp9V/MMl/0Y+ehk3Z6zNsmmHmy0F1HmU2R5yqOIt1TKC109LcYay4f7QPnqR1knXBV2h0He9TiGEOpLBZrGG0H1kiikoryr+sQ3UZygJ2CZJx+/fvdbrZLaSrkIUNG5cCeBA9hob0JIUv2G7IoOW8u6fb5dqwYeN1+yK/E/94MCw6fxGedDD603mLWrne2Usq7qdc9sE3ie+9BUASB3R1Bf5AUy9xBHcv5Vx2S21AGscCuYixOTAfzaSnz3PN06KUZ3y4t4401Yv4OQD8zD92T/UHg53IxTtoA//fPt5fgUeY7XKRZbyOsoRxdCKG6+lOl3jdyStRl+Z05AEeZRjPMYVF/M4+eVjb9XWIxaTQnVpyMixIC14w9JmRzlX/RRh0/pEOvEL/o79HnfJuOV6eyoX+vK00uMsTwb/txtncZtZ4Knq1N32zTL5l4zOHFyHNg1fuGr8zjpv9nGW05DDP+XT3m36y7fR06r14j/oBeGsi5HJilNf3NuYFtzR27knqtWHxfmEpxVKO6jSgCR24lz4MZgyv8h6zWMRy/sdODhtS43l+XWQVk7nfbovWaKf1l3ZQptESSpQCt3IevoI8aWf0XmEGzTy8+zG5Ur7Irbl8d4H45oeU43s7QWe48Bk05HE+YqMMq73Iev7DSFrmmmxtjcFkMw4vk+Ss8rWbOT8wfolhfh0Lj+JBBvkR/trd7slO8lzAeCPuslvQebZo6Mx7Lm2ty2zgKz4ghUks5HAuK/CrpDpkvwjMlcFWZjGYxh4u+KrLJ7KzSbT19FCLdv4I+ghKkevpQ17z2DCM4EXdoHF7Lt+O5LT47hTd/Kup+LBD2Z2Y45LtMKfGVQxxaZi3s/t2C93/KknbYDDJhnVnGl8yjJsCSnGmZQKYHhINdzO4LycFcCqKYqvUZ+6oRGdS+NnBuawNuHPpT22H7lZdxzdh7nWNI6xnPuN5gDo+kLa0FG9ytnFf4km5Roq2YPdvxlq7TaCxXrwgxaXn38YV7s31+/WdrqsGyAWHfqjoLb28uV1XmeH0HPp8uwFGn4JzpoGd5w4+YikT6UFtU9Klt5MpWUOB+6UcZgeYE2iAnLWdb8WVoAm9eZF5bHCZq+Iy3zGCBm4G3AZOnG2+Xmc4xHb+y3IWMpMpTGQM/ehMQxHE7h++FbUM0v+xpKTS7mexzp/ATOFJ1dbvz9ix/7tHbbbpDOx2HtzRyEEhiynNTQ7MickO+xA5L/Ah/uSgoc3XDbb37CyBWOnUWSh+/ls37GUZVpBmo4aobWNI9HyvqH1pgMuNka67yeJNr0lb+jCad1jEGhc7KfqlyCy6ecSXXZsf3S4FLpDOfnazntUsZzFzmMYkxvIUj3A/HWlGbSoE4QzhQOcZmF6VXDBWyrr7sGHtdI6XvDQNe+tyBBz0kIa0sMHnn0Z/ACqL3w8QSQQd+MVOvf8wm6EkSUKrojShH9PYbLdldJrhulH8KWlXDBafXpPWhZbJZnWQZF1MvL5nQsKdrK3TZwe43M+l22svJ51u37ly4W3kVdp4eUQuka48ygC6cw8daUkTEqlqsUzWSXInzIAbZFd52SINLSeZCnJ2gj/xMk6hlC69pY3fvNhKuk3MC8d5U+eIOirp04/bjexT3eYciGOQ3CfXstRrRu5m8Zcn6WW3Ah8kn7tp0CSuRa3VCoG2k02JR73Xa8/9AX5kInfnYdK42uJZHY4pj5WGahMLNPMBw9z/u9dtaqvz4Gbzhpe+jWK0J8lu9J/o1KifJtNau0cXGVuQM+MXA5rKHYNS3GHoAAmcEr9PC6LM54k6+4RA37eKur8OYJkV7IZqVyvudczhObrTMF8kDm3o3AKAguyUuXWLhbSJ0UzWrabSecRLozTGQAR+hgcC0qrC0puszc3zqOHF/ZE8pgsleYvr4amzgGYyEAYi+VG6O4MZeqxFAkwNgc5v1j1/YFDEzu7Kicg7wl98w8e8yEC60CAf0sOWEFPrS85GYW2NND+EOXTidfy9NpZ5ffa7lyGQdGUAj2HE8r6YmQ/zrk/px0vKozNXuF9K+1agkhx8r0fl2+gbVMm3lFudwdd+Lb+DiY2I4DMpxam0og7lVD4AgUZ8wGjnW4iTpNBSQtS4arr9/nNed4BqcpMjZ+ttrAk8RzF+BagUkEuBbMNarKAYDi5xjwxZCnZkZqS0UJKCrndtAPwrQOWlyLdglurx3ryeq6TgxoSg/kRdJPh2anu5cHiai4Z0oA0tKePOdgsJLZZxvQz10JyNMUFv27SQUaHGiZr3BqS0l6R81+QaialgQFldFxwW5Lpr6pJ5LvSSoqwDWwwbhsMszHGoX+KMl399yy5wKCkELWsv5RfswaeQjLXzHxN0AVwJqkt7i9oysDU7qENAWZ3ffrJXq9CaLLEL3KloaQmXZrWITOiv+2sDXfBQZghSc+UsAnaEzP676oTxwHtEM0VK8ZhPfhoFGuhi4KcFKUlkNL/LOr0hbYjlTcNpvUMeBPtaAeVo6BDWOUSs/o/SPmTtelwGQN0Q5Jq1mDx/yGnjWK6L26+nurKvaMoZKcgVQcnmO17W94rH9xTkKcNx2QzeDnNu41r0pktIV62Fpf33QZBr1oKiqvtcQn0ZymTjqJceJAU7tNCdcPvb9Gi0GnIWn+uh8R/FI+wzGP5fK5UHBAOle7J1UOv9ycl5SM8RxSgdr8JWn2jDFAyoonOrZTIhF7It//CFzNvrSQhSBN3tGOP+yvWQr4LnfoC10oguH8R6tTjELj7cm8hK3dvwjaV5LcIIxVmsE+tmGplUTyW59dXRg87fxe4UXiqD8lBWIyvgZmmPrQpicOy7Pp5HLcZ4HVFWNi+bclg6384GE3QnqDKYbMr20GjpbXCPRrxmOKln4zwT1GhvAoZJCX8ftPi5FzyiazeiIEMMcZ+H6ayUF2i0MuTWTWN4wBcDGilGbxf/j6adkwy/l3gjH0ZyB9sgt/F9kIZY7UC0p+nPC9DHQHSZzSdqMjAHRXnbQHDxN90DamZtcZE8IZomDGehpOjS+/vfd0N/qBAIna/UxWTWCEKNXb0IgK5Iih1H7wGSldLMRBs7t9suHg+YcfiHKHMRD9ORjtzPUN5lhYu89ad434+tIgVPUVwXmXGWgaYfENI4l9blMu/fyWI7Yo80RqmDPuYjmkF256uPMy4gMQIpHtI1nGUOXYIUmKQAJflBJ/0fTQ6sKWmX/MQepejFPAdr8DwpQaDRUhAoxhgdyVYOXeICOvo5OxQ1UGM7u/YxnbvUsY6gI0rw/WvHlGaYanudFmv5onaWSDtGs9xJFpxjvBxgAlEFD1CBtxyM872Mp7IfZZblG6eEijv4mH4qqCOk6E6qYRD4kttM2mjbpKMkK0sSj/MJf7ng8fuFnqZGpuQT+DpzxzKYoXYnrbJZzVcsZr+PZdYnmbqUAC6Tyn528idpSkUWQBnepYfhL4dYwCLWiUTYgbE1qvKZiAI8SLwbGs09LOETdii1hBqFGMifTsbmTbxgWsiQQqjQ2skyLZ0vGE5LHx1wEVSkLY8xkQVs9iDnXRZrGavO91nDAriOejzMY05OjqWykp9YzTYl5DyDroxwek4xk31s52+OcZLjnOAkJ8nW/b8AxSlJYeKIpywJxFOJRBI9HDiusIl1rGOFS/egQggHAIDC3Es/Ojhl3j3Az6xhHdsDaC4qhA438QQ9PA7AusolSvoQqJ3NEfazhw2sYwuZSuzhgDge4SvdiSz7vCireIOeJKq4/bBHNMm875Ci3b8rk918I093KPdeWFkAehTlTu6hkxsqpivsYCdb2clW9qvRPYyRSBua04K6PnXYLA6xhz3sZQ972E0GkCpsi3jl/g3XAeC6b6A97WmbC699Fkc4wAH2c5ADbOCcUklYWgTVqUMV4kmgDPGUFVqPpBRwhcuc4QqXOMMJTpLKMU6wl/1OUq3/SlsA2vCbEmteQCRNGMYcduWSQV1L4dFEiSxfY6p4E55QogjW2G0ustnABgBiaEYzmlKf6i69AKUYzACllHyMbXJxoZAnBoDrOMNylgNQiDrUoR51qEM1u62gfUol+RorySYS+FuJItx9AJ4igariqsBmJjhZFyrkJ3TjYdYxyRBHoKCgoKCgoKCgEED8P7R5UKW4ogGJAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE3LTA4LTA5VDA3OjM2OjM1KzAwOjAw/kJKjgAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxNy0wOC0wOVQwNzozNjozNSswMDowMI8f8jIAAAAASUVORK5CYII=";

interface Props {
  idPersona: string;
  idMembresiaSocio?: string;
  partnerDocuments: any;
  sendScannedFile: (
    idTipoDocumento: string,
    idMembresiaSocio: string,
    idPersona: string,
    file: Blob,
    name: string
  ) => any;
  sendEmailFile: (
    idTipoDocumento: string,
    idMembresiaSocio: string,
    idPersona: string
  ) => any;
  getDocument: (
    idTipoDocumento: string,
    idMembresiaSocio: string,
    idPersona: string
  ) => any;
  getDocumentForSign: (
    idTipoDocumento: string,
    idMembresiaSocio: string,
    idPersona: string
  ) => any;
  recreateFile: (
    idTipoDocumento: string,
    idMembresiaSocio: string,
    idPersona: string
  ) => any;
  saveDocumentSignature: (
    idTipoDocumento: string,
    idMembresiaSocio: string,
    idPersona: string,
    signature: string
  ) => any;
  authorizeDocument: (
    idTipoDocumento: number,
    idMembresiaSocio: string,
    idPersona: string
  ) => any;
  disableName: boolean;
  disableFullWidth: boolean;
  printData: object;
  partnerMembershipDocumentInstances: any[];
  showValidationAction: boolean;
  showSignAction: boolean;
  showScanAction: boolean;
  expedienteAutorizado: boolean;
}

class DocumentsTable extends React.Component<Props> {
  state = {
    signatureDocument: {
      id: ""
    }
  };

  handleFileChosen = (ev, d) => {
    ev.preventDefault();
    const { idMembresiaSocio, idPersona } = this.props;
    const file = ev.target.files[0];
    this.props.sendScannedFile(
      d.id,
      idMembresiaSocio,
      idPersona,
      file,
      `${d.id}_${idMembresiaSocio}_${idPersona}.pdf`
    );
  };

  renderCell = (d, name, colClass, cellClass, buttonClass, icon, action) => {
    if (d.acciones[`${name}`] && d.acciones[`${name}`].disponible) {
      const cellStatus =
        d.acciones[`${name}`] &&
        typeof d.acciones[`${name}`].estatus == "undefined"
          ? ""
          : d.acciones[`${name}`].estatus === "TRUE"
          ? `${cellClass} table-success`
          : `${cellClass} table-danger`;
      return (
        <div className={`${cellStatus}`}>
          <Row>
            <Col className={colClass} xs={12}>
              <label>
                <a className={buttonClass} onClick={_ => action(d)}>
                  <FontAwesomeIcon icon={icon} />
                </a>
                {name === "escanear" ? (
                  <input
                    type="file"
                    id={`scannedFile${d.id}`}
                    style={{ display: "none" }}
                    accept=".pdf"
                    onChange={e => this.handleFileChosen(e, d)}
                  />
                ) : null}
              </label>
            </Col>
          </Row>
        </div>
      );
    } else {
      return <div></div>;
    }
  };

  sendFileByEmail = d => {
    const { idMembresiaSocio, idPersona } = this.props;
    this.props.sendEmailFile(d.id, idMembresiaSocio, idPersona);
  };

  printDocument = d => {
    const { idMembresiaSocio, idPersona } = this.props;
    if (!this.props.printData) {
      this.props
        .getDocument(d.id, idMembresiaSocio, idPersona)
        .then(({ value: { data } }) => {
          const { idDocumento } = data;
          window.open(
            `${constants.BASE_URL}/${constants.DOCUMENTS_BASE_URL}/${idDocumento}`,
            "_blank"
          );
        });
    } else {
      const body = {
        idTipoDocument: d.id,
        nombreTemplate: d.contenido,
        ...this.props.printData
      };
      window.open(
        `${constants.BASE_URL}/${
          constants.DOCUMENTS_BASE_URL
        }/render?${objectToQueryParams(body)}`,
        "_blank"
      );
    }
  };

  signatureDocument = async signatureDocument => {
    const { idMembresiaSocio, idPersona } = this.props;
    const documentResponse: any = await this.props.getDocumentForSign(
      signatureDocument.id,
      idMembresiaSocio,
      idPersona
    );
    if (documentResponse.value.status == 200) {
      this.setState(state => {
        return { ...state, signatureDocument };
      });

      window.captureSignature();
      //this.saveSignatureMock(SIGNATURE_EXAMPLE, signatureDocument);
    }
  };

  scanDocument = _ => {};

  saveSignature = signature => {
    const { idMembresiaSocio, idPersona } = this.props;
    this.props.saveDocumentSignature(
      this.state.signatureDocument.id,
      idMembresiaSocio,
      idPersona,
      signature
    );
  };

  saveSignatureMock = (signature, signatureDocument) => {
    const { idMembresiaSocio, idPersona } = this.props;
    this.props.saveDocumentSignature(
      signatureDocument.id,
      idMembresiaSocio,
      idPersona,
      signature
    );
  };

  recreateFile = d => {
    const { idMembresiaSocio, idPersona } = this.props;
    this.props.recreateFile(d.id, idMembresiaSocio, idPersona);
  };

  validateDocument = d => {
    const { idMembresiaSocio, idPersona } = this.props;
    this.props.authorizeDocument(d.id, idMembresiaSocio, idPersona);
  };

  componentDidMount() {}

  getDocumentInstanceValidatedStatus = (documentId, personaId) => {
    const documentInstance = (
      this.props.partnerMembershipDocumentInstances || []
    ).find(
      ({ documento, membresiaSocio, persona }) =>
        documento == documentId && persona == personaId
    );
    if (!!documentInstance) {
      return (documentInstance.status || 0) == DOCUMENT_VALIDATED_STATUS
        ? "SI"
        : "NO";
    }
    return "NO";
  };

  getDocumentsToDisplay = () => {
    const { idPersona } = this.props;
    return (this.props.partnerDocuments || []).map(x => {
      x["validado"] = this.getDocumentInstanceValidatedStatus(
        x["id"],
        idPersona
      );
      return x;
    });
  };

  getTableColumns = () => {
    const { expedienteAutorizado } = this.props || {};

    const actionColumns = [
      {
        Header: "Email",
        id: "email",
        maxWidth: 70,
        accessor: d =>
          this.renderCell(
            d,
            "email",
            s.marginLeftNil,
            s.cellCommonStyle,
            s.emailButton,
            faEnvelope,
            this.sendFileByEmail
          )
      },
      {
        Header: "Imprimir",
        id: "imprimir",
        maxWidth: 70,
        accessor: d =>
          this.renderCell(
            d,
            "imprimir",
            s.marginLeftNil,
            s.cellCommonStyle,
            s.printButton,
            faPrint,
            this.printDocument
          )
      },
      isNil(this.props.showSignAction) || !!this.props.showSignAction
        ? {
            Header: "Firmar",
            id: "firmar",
            maxWidth: 70,
            accessor: d =>
              this.renderCell(
                d,
                "firmar",
                s.marginLeftNil,
                s.cellCommonStyle,
                s.signatureButton,
                faFileSignature,
                this.signatureDocument
              )
          }
        : null,
      isNil(this.props.showScanAction) || !!this.props.showScanAction
        ? {
            Header: "Escanear",
            id: "escanear",
            maxWidth: 70,
            accessor: d =>
              this.renderCell(
                d,
                "escanear",
                s.marginLeftNil,
                s.cellCommonStyle,
                s.scannerButton,
                faFilePrescription,
                this.scanDocument
              )
          }
        : null,
      {
        Header: "Ver",
        id: "ver",
        maxWidth: 70,
        accessor: d =>
          this.renderCell(
            d,
            "ver",
            s.marginLeftNil,
            s.cellCommonStyle,
            s.printButton,
            faEye,
            this.printDocument
          )
      },
      {
        Header: "Regenerar",
        id: "regenerar",
        maxWidth: 75,
        accessor: d =>
          this.renderCell(
            d,
            "regenerar",
            s.marginLeftNilSpecial,
            s.cellCommonStyleSpecial,
            s.regenerateButton,
            faSyncAlt,
            this.recreateFile
          )
      },
      isNil(this.props.showValidationAction) ||
      !!this.props.showValidationAction
        ? {
            Header: "Validar",
            id: "validar",
            maxWidth: 75,
            accessor: d =>
              this.renderCell(
                d,
                "validar",
                s.marginLeftNilSpecial,
                s.cellCommonStyleSpecial,
                s.regenerateButton,
                faCheck,
                this.validateDocument
              )
          }
        : null
    ];

    const columns = [];

    if (!this.props.disableName) {
      columns.push({
        Header: "Validado",
        accessor: "validado",
        className: "text-center",
        maxWidth: "80"
      });
      columns.push({
        Header: "Documento",
        accessor: "nombre",
        maxWidth: "550"
      });
    }

    columns.push({
      Header: () => "Acciones",
      columns: actionColumns.filter(x => !!x)
    });

    return columns;
  };

  render() {
    window.captureDocumentSignature = this.saveSignature;

    return (
      <div style={{ margin: "auto", width: "100%" }}>
        {this.props.partnerDocuments && (
          <ReactTable
            manual
            data={this.getDocumentsToDisplay()}
            columns={this.getTableColumns()}
            className={`-striped -highlight ${
              !this.props.disableFullWidth ? "w-100" : ""
            }`}
            style={{
              maxHeight: "400px"
            }}
            sortable={false}
            showPagination={false}
            defaultPageSize={
              this.props.partnerDocuments.length
                ? this.props.partnerDocuments.length
                : 3
            }
          />
        )}
      </div>
    );
  }
}

export default withStyles(s)(DocumentsTable);
